export default __webpack_public_path__ + "static/media/project4.9d07b406.PNG";